import React, { useEffect, useState, useCallback  } from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import './GenreManagement.css';

const GenreManagement = () => {
    const [genres, setGenres] = useState([]);
    const [name, setName] = useState('');
    const [editId, setEditId] = useState(null);
    const [loading, setLoading] = useState(false);
    const baseUrl = process.env.REACT_APP_API_BASE_URL;

    const fetchGenres = useCallback(async () => {
        try {
            const res = await fetch(`${baseUrl}/genres`);
            const data = await res.json();
            setGenres(data);
        } catch (err) {
            console.error("Failed to fetch genres:", err);
        }
    }, [baseUrl]);

    useEffect(() => {
        fetchGenres();
    }, [fetchGenres]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const token = localStorage.getItem('jwtToken');

        const method = editId ? 'PUT' : 'POST';
        const url = editId
            ? `${baseUrl}/genres/${editId}`
            : `${baseUrl}/genres`;

        const res = await fetch(url, {
            method,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ name })
        });

        if (res.ok) {
            Swal.fire('Thành công', editId ? 'Đã cập nhật thể loại!' : 'Đã thêm thể loại!', 'success');
            setName('');
            setEditId(null);
            fetchGenres();
        } else {
            Swal.fire('Lỗi', 'Có lỗi xảy ra khi lưu thể loại.', 'error');
        }
        setLoading(false);
    };

    const handleDelete = async (id) => {
        const confirm = await Swal.fire({
            title: 'Bạn có chắc?',
            text: 'Thao tác này không thể hoàn tác!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Xóa',
            cancelButtonText: 'Hủy'
        });

        if (confirm.isConfirmed) {
            const token = localStorage.getItem('jwtToken');
            const res = await fetch(`${baseUrl}/genres/${id}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (res.ok) {
                Swal.fire('Đã xóa!', 'Thể loại đã được xóa.', 'success');
                fetchGenres();
            } else {
                Swal.fire('Lỗi', 'Không thể xóa thể loại.', 'error');
            }
        }
    };

    const handleEdit = (genre) => {
        setEditId(genre.id);
        setName(genre.name);
    };

    return (
        <div className="admin-dashboard">
            <div className="back-button-container">
                <Link to="/admin" className="back-button">
                    &larr; Quay về trang quản trị
                </Link>
            </div>

            <div className="genre-management-container">
                <h1>Quản lý thể loại phim</h1>

                <form onSubmit={handleSubmit} className="genre-form">
                    <input
                        type="text"
                        placeholder="Tên thể loại"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                    />
                    <button disabled={loading}>
                        {editId ? 'Cập nhật' : 'Thêm mới'}
                    </button>
                </form>

                <table className="genre-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Tên thể loại</th>
                            <th>Hành động</th>
                        </tr>
                    </thead>
                    <tbody>
                        {genres.map((genre) => (
                            <tr key={genre.id}>
                                <td>{genre.id}</td>
                                <td>{genre.name}</td>
                                <td>
                                    <button onClick={() => handleEdit(genre)}>Sửa</button>
                                    <button onClick={() => handleDelete(genre.id)} className="delete-btn">Xóa</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default GenreManagement;
